<template>
    <div 
        id="atlas-datetime-select" 
        class="atlas-datetime-select"
    >
        <QpeDatetime
            :props_date="date"
            :props_time="time"
            :name="default_value"
            @update-time="update_time"
            @change-parent-date-time="change_parent_date_time"
        />
    </div>
</template>

<script>
import * as dayjs from 'dayjs'
import QpeDatetime from '@/components/monitor/qpe_datetime.vue'

export default {
    name: 'atlas_datetime_select',
    // 圖集功能以橫向為單位，每個橫向只能有一個小標題，側邊文字，下標
    props: {
        default_value: {
            default() {
                return ''
            },
        },
        timestamp: {},
    },

    components: {
        QpeDatetime,
    },

    data() {
        return {
            date: null,
            time: null,
        }
    },

    mounted() {
        this.date = dayjs(this.timestamp).format('YYYY-MM-DD')
        this.time = dayjs(this.timestamp).format('HH:mm')
    },

    methods: {
        get_src(image) {
            if (image.failed) {
                return image.alt_image
            }

            if (image.src == null) {
                return this.white_src
            }

            return image.src
        },

        update_time(new_datetime) {
            this.$emit('update_timestamp', dayjs(new_datetime).valueOf())
        },

        change_parent_date_time(date, time) {
            // console.log('change_parent_date_time', { date, time })
        },
    },

    watch: {},
}
</script>

<style lang="scss" scoped>
</style>
